// extracted by mini-css-extract-plugin
module.exports = {"sticky":"aboutustabs-module--sticky--1cLwu","aboutUsTabs":"aboutustabs-module--aboutUsTabs--3NeZv","stickyNav":"aboutustabs-module--stickyNav--uC9Fk"};